import axios from 'axios';
import { NavigateFunction} from 'react-router-dom';
import { encrypt } from "../../utilities/Encriptacion";

const API_URL = process.env.REACT_APP_API_KEY;
const CLAVE = process.env.REACT_APP_CLAVE_ENCRYPTION;

interface LoginResponse {
    token: string;
    company: {
        id: string;
        name: string;
        initials: string;
        image: string;
    };
}

export const login = async (nip: number, company: string | undefined, navigate: NavigateFunction, setError: any)=> {
    try {
        const response = await axios.post<LoginResponse>(`${API_URL}/auth/login`, { nip, company });
        if(response.data.company){
            sessionStorage.setItem('dataClient', encrypt(JSON.stringify(response.data.company),CLAVE));
            sessionStorage.setItem('token', response.data.token);
            sessionStorage.setItem('auth', encrypt("true", CLAVE));
            navigate(`/${company}/panel`);
            window.location.reload();
        } else {
            setError(true);
            console.log('hay error')
        }
    } catch (error: any) {
        throw new Error(error?.response?.data?.message || 'Login failed');
    }
};
